export function getValueOfKey<T extends object>(key: keyof T, object?: T) {
  return object ? object[key] : undefined;
}